module.exports = __webpack_public_path__ + "img/045-add.3c94ee17.svg";